export default "__VITE_ASSET__C1HD678Z__"